const styles = (theme) => ({
  container: {
    width: "100%",
    padding: "0px 8px 8px 8px",
    boxSizing: "border-box",
    alignSelf: "stretch",
    zIndex: 21,
    height: "calc(100% - 85px)",
  },
  headerPanelcontainer: {
    transform: "rotate(90deg)",
    transformOrigin: "left",
    paddingBottom: 40,
    fontWeight: 600,
    fontSize: 14,
    width: "max-content",
    color: theme.HeaderSelectedText,
    cursor: "pointer",
  },
  filterListContainer: {
    overflowY: "auto",
    boxSizing: "border-box",
    clear: "both",
    width: "100%",
    paddingTop: 0,
    height: "100%",
  },
  title: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  containerAction: {
    fontSize: 12,
    color: theme.iconColor,
    fontWeight: 600,
    float: "right",
    cursor: "pointer",
    padding: "12px 16px 12px 0",
    lineHeight: "20px",
    minWidth: 20,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  filterGroupItem: {
    cursor: "pointer",
    padding: "5px 0px",
  },
  filterGroupTextRoot: {
    padding: 0,
    userSelect: "none",
  },
  filterGroupText: {
    fontSize: 12,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  dotIcon: {
    fontSize: 8,
  },
  listItemIcon: {
    marginRight: 8,
  },
  toggleButtonGroupRoot: {
    paddingLeft: 8,
    paddingBottom: 8,
    borderCollapse: "collapse",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    boxSizing: "border-box",
    overflow: "visible",
    "& $toggleButtonRoot": {
      margin: 0,
      minWidth: 90,
      maxWidth: "max-content",
      borderCollapse: "collapse",
    },
  },
  toggleButtonLabel: {
    lineHeight: "20px",
    whiteSpace: "nowrap",
  },
  toggleButtonRoot: {
    "&:not(:last-child), &:not(:first-child)": {
      borderRadius: "2px",
    }
  },
  toggleButton: {
    padding: "0px 8px",
    fontSize: 12,
    maxHeight: 26,
    textTransform: "none",
    marginLeft: 8,
    marginBottom: 8,
    border: `1px solid ${theme.gridIconBorderColor}`,
    backgroundColor: "transparent",
    color: theme.gridTextColor,
    boxSizing: "border-box",
    "&:hover": {
      border: `1px solid ${theme.HeaderSelectedText}`,
      color: theme.HeaderSelectedText,
      backgroundColor: "transparent",
    },
    "&$toggleButtonSelected": {
      backgroundColor: `${theme.HeaderSelectedText}`,
      border: `1px solid ${theme.HeaderSelectedText}`,
      color: theme.white,
      "&:hover": {
        backgroundColor: `${theme.HeaderSelectedText}`,
        border: `1px solid ${theme.HeaderSelectedText}`,
        color: theme.white,
      },
    },
  },
  toggleButtonSelected: {},
  toggleButtonDisabled: {
    backgroundColor: theme.iconColor,
    color: "black",
    cursor: "not-allowed",
  },
  filtersContainer: {
    padding: 5,
    paddingLeft: 16,
    width: "100%",
    boxSizing: "border-box",
  },
  filterIcon: {
    paddingRight: 4,
    marginLeft: -2,
  },
  footer: {
    height: 35,
    fontSize: theme.textFontSize,
    padding: 5,
    backgroundColor: theme.quickFilterFooterBGColor,
    boxSizing: "border-box",
    cursor: "pointer",
    position: "absolute",
    width: "100%",
    bottom: 0,
    color: theme.TextColor,
    display: "inline-flex",
    borderTop: `1px solid ${theme.AppBGColor}`,
    alignSelf: "flex-end",
  },
  footerIcon: {
    verticalAlign: "middle",
    height: "100%",
    padding: "0 4px",
  },
  footerText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "24px",
    color: theme.TextColor,
    width: "100%",
  },
  collapseContainer: {
    width: "100%",
  },
  headerTitle: {
    display: "inline-block",
    margin: 0,
    fontSize: 14,
    padding: "12px 4px 16px 12px",
    color: theme.HeaderSelectedText,
    lineHeight: "20px",
    minWidth: 20,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  quickFilterContainer: {
    borderRadius: "4px",
    userSelect: "none",
    display: "inline-flex",
    flexDirection: "column",
  },
  message: {
    top: "48%",
    width: "90%",
    textAlign: "center",
    position: "absolute",
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    boxSizing: "border-box",
    marginLeft: "5%",
    padding: 5,
    backgroundColor: theme.loadingBGColor,
  },
  filterApplied: {
    color: theme.iconColor,
  },
  header: {
    alignSelf: "flex-start",
    width: "100%",
    display: "inline-flex",
    justifyContent: "space-between",
  },
});

export default styles;
